import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-400);
  align-self: stretch;
`;
export const Item = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-100);
  align-self: stretch;
`;
export const Label = styled.div `
  color: var(--text-primary);
  /* body/sm/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
`;
export const BarContainer = styled.div `
  display: flex;
  align-items: center;
  gap: var(--space-200);
  align-self: stretch;
`;
export const Value = styled.div `
  color: var(--text-primary);
  text-align: right;
  /* body/sm/regular */
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
`;
